import React, {useEffect, useState} from 'react';
import {Card, Table, Badge, Dropdown} from 'react-bootstrap';
import {
    filterCateringList,
    getACateringDetails,
    updateCateringStatus,
} from '../../../services/OrderService';
import CateringDetails from './CateringDetails'; // Import the new component

const svg1 = (
    <svg width='20px' height='20px' viewBox='0 0 24 24' version='1.1'>
        <g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
            <rect x='0' y='0' width='24' height='24'></rect>
            <circle fill='#000000' cx='5' cy='12' r='2'></circle>
            <circle fill='#000000' cx='12' cy='12' r='2'></circle>
            <circle fill='#000000' cx='19' cy='12' r='2'></circle>
        </g>
    </svg>
);

const CateringList = props => {
    const {cateringList, getUpcomingCaterings} = props;
    const [filteredList, setFilteredList] = useState([]);
    const [selectedFilter, setSelectedFilter] = useState('all');
    const [viewDetails, setViewDetails] = useState({});
    const [expandedRows, setExpandedRows] = useState({});
    const [loadingDetails, setLoadingDetails] = useState({});

    useEffect(() => {
        getUpcomingCaterings();
    }, [getUpcomingCaterings]);

    useEffect(() => {
        if (cateringList) {
            if (selectedFilter === 'all') {
                setFilteredList(cateringList);
            } else {
                handleFilterCatering(selectedFilter);
            }
        }
    }, [cateringList]);

    const handleUpdateCateringStatus = (eventid, status, custid) => {
        console.log('eventid, status, cust_id', eventid, status, custid);
        updateCateringStatus({eventid, status, custid})
            .then(() => getUpcomingCaterings())
            .catch(err => console.error('Error updating status:', err));
    };

    const handleFilterCatering = (status) => {
        setSelectedFilter(status);

        if (status === 'all') {
            setFilteredList(cateringList);
        } else {
            const filtered = cateringList?.filter(catering => {
                switch (status) {
                    case 'inhome':
                        return (
                            catering.serv_type.toLowerCase().trim() === 'inhome'
                        );
                    case 'bid':
                        return (
                            catering.serv_type.toLowerCase().trim() === 'bid'
                        );
                    default:
                        return true;
                }
            });
            setFilteredList(filtered || []);

            // Also call API for server-side filtering
            filterCateringList(status)
                .then(res => {
                    if (res && res.data) {
                        setFilteredList(res.data);
                    }
                })
                .catch(err =>
                    console.error('Error filtering catering list:', err)
                );
        }
    };

    // Use filteredList for rendering, fall back to cateringList only if no filter is applied
    const displayList = selectedFilter === 'all' 
        ? (filteredList.length > 0 ? filteredList : cateringList)
        : filteredList;

    const ViewDetails = eventid => {
        // If row is already expanded, close it
        if (expandedRows[eventid]) {
            setExpandedRows(prev => ({
                ...prev,
                [eventid]: false,
            }));
            return;
        }

        // If details already exist, just expand
        if (viewDetails[eventid]) {
            setExpandedRows(prev => ({
                ...prev,
                [eventid]: true,
            }));
            return;
        }

        // Set loading state
        setLoadingDetails(prev => ({
            ...prev,
            [eventid]: true,
        }));

        // Fetch details from API
        getACateringDetails(eventid)
            .then(res => {
                console.log("catering details:", res);
               
                if (res ) {
                    setViewDetails(prev => ({
                        ...prev,
                        [eventid]: res, // Handle different response structures
                    }));
                    setExpandedRows(prev => ({
                        ...prev,
                        [eventid]: true,
                    }));
                } else {
                    setExpandedRows(prev => ({
                        ...prev,
                        [eventid]: true,
                    }));
                }
            })
            .catch(err => {
                console.error('Error getting catering details:', err);
                setExpandedRows(prev => ({
                    ...prev,
                    [eventid]: true,
                }));
            })
            .finally(() => {
                setLoadingDetails(prev => ({
                    ...prev,
                    [eventid]: false,
                }));
            });
    };

    const closeDetails = eventid => {
        setExpandedRows(prev => ({
            ...prev,
            [eventid]: false,
        }));
    };

    return (
        <>
            <div className='d-sm-flex mb-lg-4 mb-2'>
                <Dropdown className='dropdown mb-2 ml-auto mr-3'>
                    <Dropdown.Toggle
                        className='i-false btn btn-primary btn-rounded light'
                        data-toggle='dropdown'
                        aria-expanded='false'
                    >
                        <i className='las la-bolt scale5 mr-3' />
                        {selectedFilter === 'all'
                            ? 'All Status'
                            : selectedFilter === 'inhome'
                            ? 'In Home'
                            : selectedFilter === 'bid'
                            ? 'Bid'
                            : 'All Status'}
                        <i className='las la-angle-down ml-3' />
                    </Dropdown.Toggle>
                    <Dropdown.Menu className='dropdown-menu dropdown-menu-center'>
                        <Dropdown.Item
                            className='dropdown-item'
                            onClick={() => handleFilterCatering('all')}
                        >
                            <span className='text-primary'>All Status</span>
                        </Dropdown.Item>
                        <Dropdown.Item
                            className='dropdown-item'
                            onClick={() => handleFilterCatering('inhome')}
                        >
                            <span className='text-success'>
                                In Home
                            </span>
                        </Dropdown.Item>
                        <Dropdown.Item
                            className='dropdown-item'
                            onClick={() => handleFilterCatering('bid')}
                        >
                            <span className='text-primary'>Bid</span>  
                        </Dropdown.Item>
                       
                    </Dropdown.Menu>
                </Dropdown>
            </div>
            <Card>
                <Card.Header>
                    <Card.Title>Live Catering Orders</Card.Title>
                </Card.Header>
                <Card.Body className='overflow-auto'>
                    <Table>
                        <thead>
                            <tr>
                                <th>
                                    <strong>EVENT ID</strong>
                                </th>
                                <th>
                                    <strong>DATE</strong>
                                </th>
                                <th>
                                    <strong>CUSTOMER</strong>
                                </th>
                                
                                <th>
                                    <strong>AMOUNT</strong>
                                </th>
                                <th>
                                    <strong>RESTAURANT STATUS</strong>
                                </th>
                                <th>
                                    <strong>CUSTOMER STATUS</strong>
                                </th>
                                <th>
                                    <strong>BID TYPE</strong>
                                </th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {displayList ? (
                                displayList.length > 0 ? (
                                    displayList.map(each => (
                                        <React.Fragment key={each.eventid}>
                                            <tr>
                                                <td>
                                                    <strong>{each.eventid}</strong>
                                                </td>
                                                <td>{each.date}</td>
                                                <td>{each.customer_name}</td>
                                                <td>SAR {each.budget || each.negotiated_amount}</td>
                                                <td>
                                                    <Badge
                                                        variant={
                                                            each?.is_rest_accepted
                                                                ? (each.bid_status === 'Confirmed' ? 'success' : 
                                                                   each.bid_status === 'Rejected' ? 'warning' : 'warning')
                                                                : 'danger'
                                                        }
                                                    >
                                                        {each?.is_rest_accepted
                                                            ? each.bid_status
                                                            : 'Not Accepted'}
                                                    </Badge>
                                                </td>
                                                <td>
                                                    <Badge
                                                        variant={
                                                            each?.is_cust_accepted
                                                                ? 'success'
                                                                : 'danger'
                                                        }
                                                    >
                                                        {each?.is_cust_accepted
                                                            ? 'Accepted'
                                                            : 'Not Accepted'}
                                                    </Badge>
                                                </td>

                                                <td>
                                                    <Badge
                                                        variant={
                                                            each.serv_type.toLowerCase().trim() ===
                                                            'inhome'
                                                                ? 'success'
                                                                : each.serv_type.toLowerCase().trim() ===
                                                                  'bid'
                                                                ? 'primary '
                                                                : 'dark text-white '
                                                        }
                                                    >
                                                        {each.serv_type}
                                                    </Badge>
                                                </td>
                                                <td>
                                                    <Dropdown>
                                                        <Dropdown.Toggle
                                                            variant={
                                                                each.status ===
                                                                'Booking Confirmed'
                                                                    ? 'success'
                                                                    : each.status ===
                                                                      'Booking Completed'
                                                                    ? 'success light'
                                                                    : each.status ===
                                                                      'Bid Created'
                                                                    ? 'warning '
                                                                    : 'dark text-white '
                                                            }
                                                            className='light sharp i-false'
                                                        >
                                                            {svg1}
                                                        </Dropdown.Toggle>

                                                        <Dropdown.Menu className='dropdown-menu dropdown-menu-right'>
                                                            {each.bid_status.toLowerCase().trim() ===
                                                                'live' && !each.rest_accepted && (
                                                                <>
                                                                    <Dropdown.Item
                                                                        className='dropdown-item'
                                                                        onClick={() => {
                                                                            handleUpdateCateringStatus(
                                                                                each.eventid,
                                                                                'true',
                                                                                each.custid
                                                                            );
                                                                        }}
                                                                    >
                                                                        <i className='las la-check-circle text-success mr-3 scale5' />
                                                                        Confirm
                                                                    </Dropdown.Item>
                                                                    <Dropdown.Item
                                                                        className='dropdown-item'
                                                                        onClick={() => {
                                                                            handleUpdateCateringStatus(
                                                                                each.eventid,
                                                                                'false',
                                                                                each.custid
                                                                            );
                                                                        }}
                                                                    >
                                                                        <i className='las la-times-circle text-danger mr-3 scale5' />
                                                                        Reject
                                                                    </Dropdown.Item>
                                                                </>
                                                            )}

                                                            <Dropdown.Item
                                                                onClick={() => ViewDetails(each.eventid)}
                                                                className='dropdown-item'
                                                            >
                                                                <i className='las la-eye mr-3 scale5' />
                                                                {loadingDetails[each.booking_id]
                                                                    ? 'Loading...'
                                                                    : expandedRows[each.booking_id]
                                                                    ? 'Hide Details'
                                                                    : 'View Details'}
                                                            </Dropdown.Item>
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                </td>
                                            </tr>
                                            {expandedRows[each.eventid] && (
                                                <CateringDetails
                                                    cateringDetails={viewDetails[each.eventid]}
                                                    isLoading={loadingDetails[each.eventid]}
                                                    onClose={closeDetails}
                                                    bookingId={each.eventid}
                                                />
                                            )}
                                        </React.Fragment>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan='9' className='text-center py-4'>
                                            <div className='d-flex flex-column align-items-center'>
                                                <i
                                                    className='las la-search-minus'
                                                    style={{
                                                        fontSize: '48px',
                                                        color: '#ccc',
                                                        marginBottom: '16px',
                                                    }}
                                                ></i>
                                                <h5 className='text-muted mb-2'>
                                                    No Catering Orders Found
                                                </h5>
                                                <p className='text-muted'>
                                                    No catering orders match the
                                                    selected filter criteria.
                                                </p>
                                            </div>
                                        </td>
                                    </tr>
                                )
                            ) : (
                                <tr>
                                    <td colSpan='9'>
                                        <div id='preloader-inner'>
                                            <div className='sk-three-bounce-inner'>
                                                <div className='sk-child sk-bounce1'></div>
                                                <div className='sk-child sk-bounce2'></div>
                                                <div className='sk-child sk-bounce3'></div>
                                                <div id='preloader-inner-bg'></div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </Card.Body>
            </Card>
        </>
    );
};

export default CateringList;